module.exports = __webpack_public_path__ + "img/partseven_pic5.49e86998.png";